import { Loader } from 'components/Widget/Loader';
import * as S from './styles';

const PreparingView = () => {
	return (
		<S.Base>
			<S.Card>
				<S.Content>
					<S.LoaderWrapper>
						<Loader size={48} />
					</S.LoaderWrapper>
					<S.Title>Preparing Your Design System</S.Title>
					<S.Subtitle>
						We're setting everything up for you. This takes about 3 minutes for small design
						systems.
					</S.Subtitle>
				</S.Content>
			</S.Card>
		</S.Base>
	);
};

export default PreparingView;
